// theme.ts
import { darken, lighten } from "@adornis/chemistry/elements/theming/color-shades";
import { DesignSystem, elevation, spacing } from "@adornis/chemistry/elements/theming/design";
import { fontFamily } from "./constants";
var colors = {
  darkgreen: "#00455C",
  seal: "#00455D",
  red: "#FF4B5B",
  grey: "#DFDFDF",
  white: "#F7F7F7",
  black: "#000000",
  background: "#E5E5E5",
  orange: "orange",
  green: "limegreen",
  // background colors
  yellow: "#FFF3D0",
  purple: "#F4EEF5",
  blue: "#E7F9FF"
};
var designSystem = {
  spacing,
  baseFontSize: 14,
  fontFamily,
  colors: {
    primary: colors.white,
    primary_50: lighten(colors.white, 8),
    primary_100: lighten(colors.white, 6),
    primary_200: lighten(colors.white, 4),
    primary_300: lighten(colors.white, 2),
    primary_400: colors.white,
    primary_500: darken(colors.white, 2),
    primary_600: darken(colors.white, 4),
    primary_700: darken(colors.white, 6),
    primary_800: darken(colors.white, 8),
    primary_900: darken(colors.white, 9),
    secondary: colors.seal,
    secondary_50: lighten(colors.seal, 8),
    secondary_100: lighten(colors.seal, 6),
    secondary_200: lighten(colors.seal, 4),
    secondary_300: lighten(colors.seal, 2),
    secondary_400: colors.seal,
    secondary_500: darken(colors.seal, 2),
    secondary_600: darken(colors.seal, 4),
    secondary_700: darken(colors.seal, 6),
    secondary_800: darken(colors.seal, 8),
    secondary_900: darken(colors.seal, 9),
    accent: colors.red,
    accent_50: lighten(colors.red, 8),
    accent_100: lighten(colors.red, 6),
    accent_200: lighten(colors.red, 4),
    accent_300: lighten(colors.red, 2),
    accent_400: colors.red,
    accent_500: darken(colors.red, 2),
    accent_600: darken(colors.red, 4),
    accent_700: darken(colors.red, 6),
    accent_800: darken(colors.red, 8),
    accent_900: darken(colors.red, 9),
    white: colors.white,
    black: colors.black,
    light: darken(colors.white, 0.5),
    neutral_50: darken(colors.white, 0.5),
    neutral_100: darken(colors.white, 1),
    neutral_200: darken(colors.white, 2),
    neutral_300: darken(colors.white, 3),
    neutral_400: darken(colors.white, 4),
    neutral_500: darken(colors.white, 5),
    neutral_600: darken(colors.white, 6),
    neutral_700: darken(colors.white, 7),
    neutral_800: darken(colors.white, 8),
    neutral_900: darken(colors.white, 9),
    dark: darken(colors.white, 9),
    tone: {
      active: colors.red,
      success: colors.green,
      warning: colors.orange,
      error: colors.seal
    },
    on: {
      primary: colors.seal,
      primary_50: colors.seal,
      primary_100: colors.seal,
      primary_200: colors.seal,
      primary_300: colors.seal,
      primary_400: colors.seal,
      primary_500: colors.seal,
      primary_600: colors.seal,
      primary_700: colors.white,
      primary_800: colors.white,
      primary_900: colors.white,
      secondary: colors.white,
      secondary_50: colors.black,
      secondary_100: colors.black,
      secondary_200: colors.black,
      secondary_300: colors.white,
      secondary_400: colors.white,
      secondary_500: colors.white,
      secondary_600: colors.white,
      secondary_700: colors.white,
      secondary_800: colors.white,
      secondary_900: colors.white,
      accent: colors.white,
      accent_50: colors.black,
      accent_100: colors.black,
      accent_200: colors.black,
      accent_300: colors.black,
      accent_400: colors.white,
      accent_500: colors.white,
      accent_600: colors.white,
      accent_700: colors.white,
      accent_800: colors.white,
      accent_900: colors.white,
      white: colors.black,
      black: colors.white,
      light: colors.black,
      neutral_50: colors.black,
      neutral_100: colors.black,
      neutral_200: colors.black,
      neutral_300: colors.black,
      neutral_400: colors.black,
      neutral_500: colors.black,
      neutral_600: colors.white,
      neutral_700: colors.white,
      neutral_800: colors.white,
      neutral_900: colors.white,
      dark: colors.white,
      tone: {
        active: colors.white,
        success: colors.white,
        warning: colors.white,
        error: colors.white
      }
    }
  },
  borders: {},
  shadows: elevation,
  sizes: {
    borderRadius: "25px",
    borderRadiusSecondary: "5px",
    maxReadableWidth: "500px",
    maxPageWidth: "1080px"
  }
};
DesignSystem.setTheme("ge", designSystem);
export {
  colors,
  designSystem
};
